import type { FieldConfiguration } from "../../../../../../../../api/types/fieldConfigurationTypes.ts";
import type { DimensionField } from "../../../../../../../../api/types/svTypes.ts";
import CustomLabel from "../../../viewer/common/fields/CustomLabel.tsx";
import FieldOptionDeleteButton from "../../../viewer/common/fields/FieldOptionDeleteButton.tsx";
import FieldOptionsDivider from "../../../viewer/common/fields/FieldOptionsDivider.tsx";
import DimensionAggregation from "../../common/fields/dimension-aggregation/DimensionAggregation.tsx";
import useDimensionFieldOptions from "../../common/fields/dimensions/hooks/useDimensionFieldOptions.ts";
import ListFreezeField from "./ListFreezeField.tsx";

interface Props {
  field: DimensionField;
  readonly: boolean;
  cancel: () => void;
  onRemove: () => void;
  onUpdateConfiguration: (changes: Partial<FieldConfiguration>, causeClosing: boolean) => void;
  onUpdateCustomLabel: (name: string | undefined) => void;
}

export default function ListDimensionFieldOptions({
  field,
  readonly,
  cancel,
  onRemove,
  onUpdateConfiguration,
  onUpdateCustomLabel,
}: Props) {
  const { handleRemove, onUpdateAggregation } = useDimensionFieldOptions({
    field,
    cancel,
    onRemove,
    onUpdateConfiguration,
  });

  return (
    <>
      <CustomLabel
        customFieldValue={field.config.customLabel}
        originalFieldValue={field.meta.caption}
        updateCustomFieldValue={onUpdateCustomLabel}
        readonly={readonly}
      />
      <FieldOptionsDivider />
      {field.meta.options?.supportAggregation !== false && (
        <DimensionAggregation
          field={field}
          onChange={onUpdateAggregation}
          hideAggregationType={!!field.config.persistedAggregationName}
          hideDateRange
          readonly={readonly}
        />
      )}
      <ListFreezeField field={field} readonly={readonly} />
      <FieldOptionsDivider />
      {!readonly && <FieldOptionDeleteButton onRemove={handleRemove} />}
    </>
  );
}
